<template>
    <div class="frmszemelyesadatok_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>

        <div style="width:100%; box-sizing: border-box; text-align: left; margin:20px 0px;">
            <span @click="PrintTagsagiJogviszonyIgazolas" class="cms_linkbutton cms_linkbutton_GREEN_FULL" style="padding-left:20px; padding-right: 20px;">
                <i class="fal fa-file-pdf" style="margin-right:8px; vertical-align: middle; font-size: 22px; line-height: 22px;"></i>
                <span style="font-weight: 500; font-size: 15px; line-height: 15px; vertical-align: middle;">Tagsági jogviszony igazolás</span>
            </span>
        </div>

        <div class="frmszemelyesadatok_cont">
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtTagkodEsNev" grc_labeltext="Tagkód - név:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtAnyjaNeve" grc_labeltext="Édesanyja neve:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>

            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtSzuletett" grc_labeltext="Született:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtAdoazon" grc_labeltext="Adóazonosító jel:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>

            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtOkmanySzam" grc_labeltext="Azonosító okmány:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtLakcimKartya" grc_labeltext="Lakcím kártya:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>

            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtAllCim" grc_labeltext="Állandó cím:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>

            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtLevCim" grc_labeltext="Levelezési cím:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>


            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtMunkNev" grc_labeltext="Munkáltató:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtMegjegyzes" grc_labeltext="Megjegyzés:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtBelepesDatuma" grc_labeltext="Belépés dátuma:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>
            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtZaradekDatuma" grc_labeltext="Záradék dátuma:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>

            <div class="frmszemelyesadatok_itemcont">
                <GrcText ref="txtBankszamlaszam" grc_labeltext="Bankszámlaszám:"
                grc_placeholder="..." grc_readonly="true"
                grc_labelmode="above" grc_labelwidth="200px" 
                v-on:grc-keydown-enter="SetControlToFocus('');"
                />
            </div>

        </div>



    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'


export default {
  name: 'frmszemelyesadatok',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
      GrcDocDisplayer
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmszemelyesadatok_",

      }
  },
  model: {

  },  
  methods:{

    async PrintTagsagiJogviszonyIgazolas()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };


        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "GetReport", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var docb64 = Q.RESULT[0].DocData;
        var docfn = Q.RESULT[0].FajlNev;
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi


        //console.log(Q);
        //return;

        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        // grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowResult(docresult, 200);
        }

    },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },



    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmszemelyesadatok", pCompName);
    },

    SetLang()
    {
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.$refs.txtTagkodEsNev.SetText(Q.RESULT[0].TagkodEsNev);
        this.$refs.txtAnyjaNeve.SetText(Q.RESULT[0].AnyjaNeve);
        this.$refs.txtSzuletett.SetText(Q.RESULT[0].Szuletett);
        this.$refs.txtAdoazon.SetText(Q.RESULT[0].Adoazon);
        this.$refs.txtOkmanySzam.SetText(Q.RESULT[0].OkmanySzam);
        this.$refs.txtLakcimKartya.SetText(Q.RESULT[0].LakcimKartya);
        this.$refs.txtAllCim.SetText(Q.RESULT[0].AllCim);
        this.$refs.txtLevCim.SetText(Q.RESULT[0].LevCim);
        this.$refs.txtMunkNev.SetText(Q.RESULT[0].MunkNev);
        this.$refs.txtMegjegyzes.SetText(Q.RESULT[0].Megjegyzes);
        this.$refs.txtBankszamlaszam.SetText(Q.RESULT[0].Bankszamlaszam);
        this.$refs.txtBelepesDatuma.SetText(Q.RESULT[0].BelepesDatuma);
        this.$refs.txtZaradekDatuma.SetText(Q.RESULT[0].ZaradekDatuma);


      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


